import { render, staticRenderFns } from "./AverageBasketItems.vue?vue&type=template&id=71d39bc1"
import script from "./AverageBasketItems.vue?vue&type=script&lang=js"
export * from "./AverageBasketItems.vue?vue&type=script&lang=js"
import style0 from "./AverageBasketItems.vue?vue&type=style&index=0&id=71d39bc1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports